import * as React from 'react';
import { useIntl } from 'react-intl';
import colors from '../../../../../../config/theme/colors';
import ActionButton from 'Components/ActionButton';
import { ClearIconStyled } from '..';
import type { IExtendedSearchField } from '../ExtendedSearchField';
import SeizureClassificationComponent from './components/SeizureClassificationComponent';

const SeizureClassificationField = ({ searchFields, onChange }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string, values?: Record<string, (chunks: string[]) => React.JSX.Element>) =>
    formatMessage({ id }, values);

  const criteria: Array<TSeizureClassification | undefined> = Array.isArray(searchFields.seizureClassification)
    ? searchFields.seizureClassification
    : [undefined];

  const onChangeCriteria = (i: number) => (values: TOnChangeValues) => {
    const newClassification = values['seizureClassification'] as
      | { classification: TSeizureClassification; group: string }
      | undefined;

    const newCriteria: Array<TSeizureClassification | undefined> = structuredClone(
      Array.isArray(searchFields.seizureClassification) && searchFields.seizureClassification.length > 0
        ? searchFields.seizureClassification
        : [undefined],
    );
    newCriteria[i] = newClassification?.classification ?? undefined;
    onChange({ seizureClassification: newCriteria });
  };

  return (
    <React.Fragment>
      {criteria.map((item, i, arr) => (
        <React.Fragment key={`seizureClassificationCriteria${i}`}>
          <div
            style={{
              backgroundColor: colors.lightestGray,
              padding: '1rem',
              marginBottom: i === arr.length - 1 ? '1rem' : undefined,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ marginBottom: '1rem', color: colors.tertiaryText }}>
                {fm('extendedSearch.searchCriteriaTitle')}
                {` ${i + 1}`}
              </div>
              {arr.length > 1 && (
                <ClearIconStyled
                  onClick={() => {
                    const filtered = arr.filter((_, index) => index !== i);
                    onChange({
                      seizureClassification: filtered.length > 0 ? filtered : 'noCropping',
                    });
                  }}
                />
              )}
            </div>
            <SeizureClassificationComponent {...{ item, i, criteria, onChangeCriteria }} />
          </div>
          {arr.length > 1 && i < arr.length - 1 && (
            <div style={{ padding: '1rem', textTransform: 'uppercase' }}>{fm('general.and')}</div>
          )}
        </React.Fragment>
      ))}
      <div style={{ marginTop: '2rem', justifyContent: 'center' }}>
        <ActionButton
          text={'extendedSearch.addSearchCriteria'}
          onClick={() => {
            const newCriteria = structuredClone(
              Array.isArray(searchFields.seizureClassification) && searchFields.seizureClassification.length > 0
                ? searchFields.seizureClassification
                : [undefined],
            );
            newCriteria.push(undefined);
            onChange({ seizureClassification: newCriteria });
          }}
          width={16}
          height={3}
          fontSize={16}
        />
      </div>
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'searchFields' | 'onChange'> {}

export default SeizureClassificationField;
